export const replaceSpecialCharactersData = (data) => {
  const commaPlaceholder = "";
  return data.map((item) => {
    return {
      value: item.value.replace(",", commaPlaceholder),
      label: item.label,
      data: item.value,
    };
  });
};

export const replaceSpecialCharactersString = (data) => {
  const commaPlaceholder = "";
  return data.replace(",", commaPlaceholder);
};

export const replaceBackSpecialCharactersString = (data) => {
  const commaPlaceholder = "__COMMA__";
  return data.replace(commaPlaceholder, ",");
};
